import { FullPageLoader } from "@components/Loader";
import { BASE_LOGIN_URL } from "config/index";
import { useRouter } from "next/router";
import React, { Fragment, useEffect } from "react";
import { useAppSelector } from "store/hooks";

function AuthGuard({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement {
  const { isLoggedIn, isInitialized } = useAppSelector((state) => state.user);
  const router = useRouter();

  useEffect(() => {
    if (router.isReady && isInitialized && !isLoggedIn) {
      router.replace({
        pathname: BASE_LOGIN_URL,
        query: {
          next: router.asPath,
        },
      });
    }
  }, [isLoggedIn, router, isInitialized]);

  if (!isLoggedIn) return <FullPageLoader />;

  return <Fragment>{children}</Fragment>;
}

export default AuthGuard;
